<template>
    <hts-modal
        :show="visible"
        :title="$t('labels.deleteDebit')"
        type="confirm"
        :content="$t('labels.confirmDeleteDebit')"
        @close="close"
        @confirm="() => handleDelete()" />
</template>

<script setup lang="ts">
const visible = ref(false)

const emits = defineEmits(['close', 'refreshTables'])
const id = ref('')
const tripId = ref('')
const close = () => {
  visible.value = false
  emits('close')
}

const handleDelete = () => {
  const api = {
    url: `/trip/${tripId.value}/billing-and-costing/payment-note`,
    method: 'delete'
  }

  $api(api, { body: { ids: [id.value] } }).then((data: any) => {
    const resData: any = data?.data?.value
    if (resData?.success) {
      process.client && $toast().success($t('labels.deleteSuccess'))
      emits('refreshTables')
      close()
    }
  })
}

const open = (tId: string, idDebit: string) => {
  id.value = idDebit
  tripId.value = tId
  visible.value = true
}

defineExpose({
  open
})
</script>
